/** Covers the chat while files are dragged over it. */
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { Box, Typography } from '@mui/material';

export function DropOverlay() {
  return (
    <Box
      aria-hidden
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        border: '2px dashed',
        borderColor: 'primary.main',
        borderRadius: 1,
        bgcolor: 'background.paper',
        opacity: 0.94,
        pointerEvents: 'none',
      }}
    >
      <AttachFileIcon color="primary" />
      <Typography variant="body1" color="primary">
        Drop files to attach them to your question
      </Typography>
    </Box>
  );
}
